import React, { useEffect, useState } from "react";
import { getOrganizationSettings, saveOrganizationSettings } from "../../api/adminApi";

const OrganizationSettings = () => {

  const [isLoading, setLoading] = useState(false);
  const [settingsData, setSettingsData] = useState({
    apiAddress: "",
    apiKey: "",
    apiToken: "",
    username: "",
    password: "",
    useApiKey: false,
    useEmailApi: false,
    emailApi: "",
    useSmsApi: false,
    smsApi: "",
  });

  useEffect(() => {
    fetchOrganizationSettings();
  }, []);

  const fetchOrganizationSettings = async () => {
    setLoading(true);
    setSettingsData([]);

    try {
      const response = await getOrganizationSettings();
      if (response.status === 200) {
        console.log(response.data);

        setSettingsData({
          apiAddress: response.data.apiAddress || "",
          apiKey: response.data.apiKey || "",
          apiToken: response.data.apiToken || "",
          username: response.data.username || "",
          password: response.data.password || "",
          useApiKey: response.data.useApiKey || false,
          useEmailApi: response.data.useEmailApi || false,
          emailApi: response.data.emailApi || "",
          useSmsApi: response.data.useSmsApi || false,
          smsApi: response.data.smsApi || "",
        });
      }
    } catch (error) {
      alert("Failed to fetch Settings Information. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSettingsData({
      ...settingsData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveOrganizationSettings(settingsData);
      alert("Settings saved successfully.");
    } catch (error) {
      alert("Failed to save settings. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-lg">
      <h1 className="text-2xl font-semibold mb-4">Organization Settings</h1>
      {isLoading ? (
        <p className="text-center text-gray-500">Loading...</p>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="flex flex-col">
            <label htmlFor="apiAddress" className="text-sm font-medium text-gray-700">API Address</label>
            <input
              type="text"
              id="apiAddress"
              name="apiAddress"
              value={settingsData.apiAddress}
              onChange={handleInputChange}
              className="mt-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="apiKey" className="text-sm font-medium text-gray-700">API Key</label>
            <input
              type="text"
              id="apiKey"
              name="apiKey"
              value={settingsData.apiKey}
              onChange={handleInputChange}
              className="mt-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="apiToken" className="text-sm font-medium text-gray-700">API Token</label>
            <input
              type="text"
              id="apiToken"
              name="apiToken"
              value={settingsData.apiToken}
              onChange={handleInputChange}
              className="mt-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="username" className="text-sm font-medium text-gray-700">Username</label>
            <input
              type="text"
              id="username"
              name="username"
              value={settingsData.username}
              onChange={handleInputChange}
              className="mt-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="password" className="text-sm font-medium text-gray-700">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={settingsData.password}
              onChange={handleInputChange}
              className="mt-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div className="flex items-center">
            <input
              type="checkbox"
              id="useApiKey"
              name="useApiKey"
              checked={settingsData.useApiKey}
              onChange={handleInputChange}
              className="h-4 w-4 text-blue-500 border-gray-300 rounded"
            />
            <label htmlFor="useApiKey" className="ml-2 text-sm text-gray-700">Use API Key</label>
          </div>

          <div className="flex items-center">
            <input
              type="checkbox"
              id="useEmailApi"
              name="useEmailApi"
              checked={settingsData.useEmailApi}
              onChange={handleInputChange}
              className="h-4 w-4 text-blue-500 border-gray-300 rounded"
            />
            <label htmlFor="useEmailApi" className="ml-2 text-sm text-gray-700">Use Email API</label>
          </div>
          <div className="flex flex-col">
            <label htmlFor="emailApi" className="text-sm font-medium text-gray-700">Email Api Endpoint</label>
            <input
              type="text"
              id="emailApi"
              name="emailApi"
              value={settingsData.emailApi}
              onChange={handleInputChange}
              className="mt-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div className="flex items-center">
            <input
              type="checkbox"
              id="useSmsApi"
              name="useSmsApi"
              checked={settingsData.useSmsApi}
              onChange={handleInputChange}
              className="h-4 w-4 text-blue-500 border-gray-300 rounded"
            />
            <label htmlFor="useSmsApi" className="ml-2 text-sm text-gray-700">Use Sms API</label>
          </div>
          <div className="flex flex-col">
            <label htmlFor="smsApi" className="text-sm font-medium text-gray-700">Sms Api Endpoint</label>
            <input
              type="text"
              id="smsApi"
              name="smsApi"
              value={settingsData.smsApi}
              onChange={handleInputChange}
              className="mt-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div className="mt-4">
            <button
              type="submit"
              className="w-full p-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              Save Settings
            </button>
          </div>
        </form>
      )}
    </div>
  );
}

export default OrganizationSettings;